import {
  Col,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  InputNumber,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";

import notfound from "../assets/images/not_found.png";
import SingleImageUpload from "../components/SingleImageUpload";
import { Severty, ShowToast } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";

const SendMediaForm = ({ show, hide, data, refresh, section, useFor, api }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [image, setImage] = useState();
  const [loading, setLoading] = useState(false);
  const [userChallenges, setUserChallenges] = useState([]);
  const [type, setType] = useState("all");
  const supportedVideoExtensions = [".mp4", ".ogg", ".webm", ".mpeg"];
  const [uploadedUrl, setUploadedUrl] = useState(null);
  const [s3Url, setS3Url] = useState(null);

  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
    "video/mp4",
    "video/ogg",
    "video/webm",
    "video/mpeg",
  ];

  // const handleImage = (data) => {
  //   // data.length > 0 ? setImage(data[0].url) : setImage([]);
  //   setImage(data);
  //   setUploadedUrl(data?.[0]?.url || null);
  // };
  const handleImage = (data) => {
    const file = data?.[0];
    const uploadedUrl = file?.url || file?.response?.location;

    if (uploadedUrl) {
      setImage([
        {
          uid: file.uid,
          name: file.name,
          status: 'done',
          url: uploadedUrl,
        },
      ]);
      setS3Url(uploadedUrl);
    }
  };


  const getChallenges = () => {
    request({
      url: apiPath.getUserChallenges + `?type=${type}`,
      method: "GET",
      onSuccess: (data) => {
        setUserChallenges(data?.data?.data || []);
      },
      onError: (err) => {
        console.log(err);
        ShowToast("Something went wrong!", Severty.ERROR);
      }
    })
  }

  const onCreate = (values) => {
    console.log(values, "values");
    console.log("Form values:", values);
    console.log("Uploaded image state:", image); // Add this
    setLoading(true);
    const payload = {
      ...values,
      useFor: useFor,
      url: s3Url,
    };

    // if (image?.length > 0) {
    //   let isVideo = supportedVideoExtensions.some((ext) => image?.toLowerCase()?.endsWith(ext));
    //   payload.url = image;
    //   payload.type = isVideo ? "Video" : "Image"
    // }
    if (image?.length > 0) {
      const uploadedUrl = image[0]?.url;
      let isVideo = supportedVideoExtensions.some((ext) =>
        uploadedUrl?.toLowerCase()?.endsWith(ext)
      );

      payload.url = uploadedUrl;
      payload.type = isVideo ? "Video" : "Image";
    }



    request({
      url: `${api.addMedia}/${data?._id}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    // getChallenges(type);
  }, [type]);

  return (
    <Modal
      open={show}
      maskClosable={false}
      width={750}
      okText={'Send'}
      cancelText={`Cancel`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form
        id="create"
        form={form}
        onFinish={onCreate}
        layout="vertical"
        initialValues={{
          is_active: true,
        }}
      >
        <h4 className="modal_title_cls">
          {"Send New "} {section}
        </h4>
        <Row gutter={[16, 0]}>
          <Col span={24} sm={useFor !== "UserChallenge" ? 12 : 24}>
            <Form.Item
              label={<> {`Title`}</>}
              name="title"
            
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`Enter Title`} />
            </Form.Item>
          </Col>
          <Col span={24} sm={useFor !== "UserChallenge" ? 12 : 24}>
            <Form.Item
              label="Description"
              name="description"
             
            >
              <Input.TextArea
                rows={4}
                placeholder="Enter description"
                autoSize={{ minRows: 3, maxRows: 6 }}
              />
            </Form.Item></Col>


          <Col span={24} sm={12}>
            <Form.Item
              label={<> {"Day Number"}</>}
              name="day_number"

              rules={[
                {
                  required: true,
                  message: "Day Number is required",
                },
                {
                  validator: (_, value) => {
                    if (value <= 0) {
                      return Promise.reject("Day Number must be greater than zero");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                autoComplete="off"
                placeholder={`Enter Day Number`}
              />
            </Form.Item>
          </Col>

          <Col span={24} sm={useFor !== "UserChallenge" ? 12 : 24}>
            <Form.Item
              label={<> {`Link`}</>}
              name="link"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const imageValue = getFieldValue("image");
                    if (!value && (!imageValue || imageValue.length === 0)) {
                      return Promise.reject(new Error("Either Link or Content must be provided"));
                    }
                    if (value && imageValue?.length > 0) {
                      return Promise.reject(new Error("Cannot enter Link when Content is uploaded"));
                    }
                    return Promise.resolve();
                  },
                }),

                {
                  max: 200,
                  message: "Link should not contain more then 200 characters!",
                },
                {
                  min: 2,
                  message: "Link should contain at least 2 characters!",
                },
                // ({ getFieldValue }) => ({
                //   validator(_, value) {
                //     const imageValue = getFieldValue("image");
                //     if (value && imageValue?.length > 0) {
                //       return Promise.reject(new Error("Cannot enter Link when Image is uploaded"));
                //     }
                //     return Promise.resolve();
                //   },
                // }),

              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`Enter Link`} />
            </Form.Item>
          </Col>

          <Col span={24} sm={12}>
            <Form.Item
              className=""
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const linkValue = getFieldValue("link");
                    if ((!value || value.length === 0) && (!linkValue || linkValue === "")) {
                      return Promise.reject(new Error("Either Content or Link must be provided"));
                    }
                    if (value?.length > 0 && linkValue) {
                      return Promise.reject(new Error("Cannot upload Content when Link is entered"));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              label={"Upload Content"}
              name="image"
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"Content"}
                btnName={"Content"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>
            {image && (
              <div className="mt-2 add-img-product">
                {/* {typeof image === "string" &&
                  supportedVideoExtensions?.some((ext) =>
                    image.toLowerCase().endsWith(ext)
                  ) ? (
                  <video controls src={image} />
                ) : (
                  <Image width={120} src={image ?? notfound} />
                )} */}
                {image?.length > 0 &&
                  supportedVideoExtensions.some((ext) =>
                    image[0]?.url?.toLowerCase().endsWith(ext)
                  ) ? (
                  <video controls src={image[0]?.url} />
                ) : (
                  <Image width={120} src={image[0]?.url ?? notfound} />
                )}

              </div>
            )}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SendMediaForm;
